import axios from 'axios';
import ChangeTab from '@js/directives/ChangeTab';
import { config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import lang from './vue-i18n';
import PortalVue from 'portal-vue';
import vClickOutside from 'v-click-outside';
import Vue from 'vue';

// Tell fontawesome to not load CSS
config.autoAddCss = false;

// Load up ziggy and our routes
// if (process.env.NODE_ENV === 'production') {
//     require('./vue-routes.js');
// }

// Initialize an event bus via Vue
window.Events = new Vue();

// Helpers
Vue.prototype.$axios = axios;
Vue.prototype.$trans = lang;
Vue.prototype.$locale = document.documentElement.lang;

// Directives
Vue.directive('change-tab', ChangeTab);

// Use
Vue.use(PortalVue);
Vue.use(vClickOutside);

// Filters
Vue.filter('trans', (...args) => {
    return lang.get(...args);
});

// Third-party components
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Our components
Vue.component('app-basic-dropdown', require('@js/components/App/BasicDropdown.vue').default);
Vue.component('app-datepicker', require('@js/components/App/Datepicker.vue').default);
Vue.component('app-dropdown', require('@js/components/App/Dropdown.vue').default);
Vue.component('app-loader', require('@js/components/App/Loader.vue').default);
Vue.component('app-login', require('@js/components/App/Login.vue').default);
Vue.component('app-logout', require('@js/components/App/Logout.vue').default);
Vue.component('app-navbar', require('@js/components/App/Navbar.vue').default);
Vue.component('app-select', require('@js/components/App/Select.vue').default);
Vue.component('app-tag-input', require('@js/components/App/TagInput.vue').default);
Vue.component('app-toggle-button', require('@js/components/App/ToggleButton.vue').default);

// Backend "pages"
Vue.component('backend-announcements-index', require('@js/components/Backend/AnnouncementsIndex.vue').default);
Vue.component('backend-client-leases-index', require('@js/components/Backend/ClientLeasesIndex.vue').default);
Vue.component('backend-documents-manage', require('@js/components/Backend/DocumentsManage.vue').default);
Vue.component('backend-employee-leases-index', require('@js/components/Backend/EmployeeLeasesIndex.vue').default);
Vue.component('backend-points-index', require('@js/components/Backend/PointsIndex.vue').default);
Vue.component('backend-properties-index', require('@js/components/Backend/PropertiesIndex.vue').default);
Vue.component('backend-roles-index', require('@js/components/Backend/RolesIndex.vue').default);
Vue.component('backend-sources-index', require('@js/components/Backend/SourcesIndex.vue').default);
Vue.component('backend-users-form', require('@js/components/Backend/UsersForm.vue').default);
Vue.component('backend-users-index', require('@js/components/Backend/UsersIndex.vue').default);

// Frontend "pages"
Vue.component('frontend-users-profile', require('@js/components/Frontend/UsersProfile.vue').default);

const app = new Vue({
    el: '#app',
});
